import React from 'react';
import Footer from '../Components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="overflow-x-hidden bg-white text-black">
      {/* Header */}
      <div className="bg-[#BB005A] text-white py-12 px-4 text-center">
        <h1 className="text-3xl md:text-5xl font-bold">Privacy Policy</h1>
        <p className="mt-2 text-sm md:text-lg">
          Oxford Study Center – Protecting Your Information
        </p>
      </div>

      {/* Content */}
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-16 space-y-10">
        
        <section>
          <p className="text-sm text-gray-600">
            <strong>Effective Date:</strong> January 2025 <br />
            <strong>Last Updated:</strong> January 2025
          </p>
        </section>

        <section>
          <p className="text-sm md:text-lg text-gray-700">
            Oxford Study Center (“we”, “our”, or “the School”) is committed to protecting
            the privacy and personal information of students, parents or guardians,
            staff, and users of our digital platforms. This Privacy Policy explains how
            we collect, use, store, and protect personal information within our school
            management system.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">1. Information We Collect</h2>
          <ul className="list-disc pl-6 space-y-2 text-sm md:text-lg text-gray-700">
            <li><strong>Student Information:</strong> name, date of birth, student ID, class, subjects, academic results, and financial records.</li>
            <li><strong>Parent / Guardian Information:</strong> name, phone number, email address, and relationship to the student.</li>
            <li><strong>Staff Information:</strong> name, role, login credentials, and academic data entered into the system.</li>
            <li><strong>System Data:</strong> login timestamps, device information, browser type, and IP address for security purposes.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">2. How We Use Information</h2>
          <ul className="list-disc pl-6 space-y-2 text-sm md:text-lg text-gray-700">
            <li>Manage and display student academic results</li>
            <li>Process and track school fees and financial records</li>
            <li>Enable teachers to enter and manage results</li>
            <li>Communicate academic and administrative information</li>
            <li>Maintain platform security and integrity</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">3. Access Control</h2>
          <p className="text-sm md:text-lg text-gray-700">
            Access to information is strictly controlled. Students and parents can only
            view their own records. Teachers can only access assigned classes and
            subjects. Administrators have role-based access depending on their duties.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">4. Data Security</h2>
          <p className="text-sm md:text-lg text-gray-700">
            We use reasonable technical and organizational measures such as secure
            authentication, encrypted passwords, and controlled access to protect
            personal information. While we strive for strong security, no system is
            completely risk-free.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">5. Data Sharing</h2>
          <p className="text-sm md:text-lg text-gray-700">
            We do not sell or rent personal data. Information may only be shared when
            required by law, with authorized service providers, or with consent from
            parents or guardians.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">6. Children’s Privacy</h2>
          <p className="text-sm md:text-lg text-gray-700">
            This platform is designed for educational use. Student information is
            collected solely for academic and administrative purposes and handled in
            accordance with applicable data protection laws.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">7. Policy Updates</h2>
          <p className="text-sm md:text-lg text-gray-700">
            This Privacy Policy may be updated periodically. Any changes will be posted
            on this page with an updated effective date.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">8. Contact Us</h2>
          <p className="text-sm md:text-lg text-gray-700">
            If you have questions or concerns about this Privacy Policy, please contact:
          </p>
          <p className="mt-2 text-sm md:text-lg text-gray-700">
            <strong>Oxford Study Center</strong><br />
            Email: info@osc.co.zw<br />
            Phone: +263 771472707
          </p>
        </section>

      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
